import o from"@mui/material/Typography";import{styled as r}from"@mui/material/styles";const t=r(o)((({theme:o,ownerState:r})=>({...r.color&&{color:o.palette[r.color].main}})));export{t as StyledTypography};
//# sourceMappingURL=styles.js.map
